Application.Forms.Validators.BaseValidator = {
    on: {
        submit: true,
        change: false,
        keydown: false,
        focus: false,
        blur: false,
        ready: false,
    },
    onError: function (el, message) {},
    onSuccess: function (el) {}
}